import { createSelector } from "@reduxjs/toolkit"
import { parseRecentSearches } from "@nova/schemas"
import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"
import { selectAllMembers } from "features/entity-caching/members/UserManagementSlice"
import { selectUserID } from "user/profile/selectors"
import { hydrateRecentSearches } from "./registry"

export const selectRecentSearchResults = createSelector(
    [selectAllMembers(), selectActiveWorkspaceId(), selectUserID],
    (allMembers, activeWorkspaceId, userId) => {
        const membersOfWorkspace = allMembers[activeWorkspaceId || ""]
        const activeMember = membersOfWorkspace?.find((m) => m.userId === userId)

        const rawEntries = parseRecentSearches(activeMember?.recentSearches)
        const sortedEntries = [...rawEntries].sort((a, b) => b.timestamp.localeCompare(a.timestamp))
        return hydrateRecentSearches(sortedEntries)
    }
)
